import { useState } from 'react';
import { createPaypalSubscription, getPaypalPlanIdForTier } from '@/services/paypalService';
import { supabase } from '@/integrations/supabase/client';

export const useProviderPayment = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const initiateProviderSubscription = async () => {
    setIsProcessing(true);
    setError(null);
    
    try {
      console.log('Initiating provider subscription...');
      const planId = getPaypalPlanIdForTier('provider', 'annual');
      console.log('Using plan ID:', planId);
      
      const result = await createPaypalSubscription(planId);
      
      if (result.success && result.approve_url) {
        console.log('Redirecting to PayPal:', result.approve_url);
        window.location.href = result.approve_url;
        return { success: true };
      } else {
        const errorMsg = result.error || 'Failed to initiate payment';
        setError(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (err: any) {
      console.error('Error in initiateProviderSubscription:', err);
      setError(err.message);
      return { success: false, error: err.message };
    } finally {
      setIsProcessing(false);
    }
  };

  const checkProviderPaymentStatus = async (userId: string) => {
    try {
      const { data, error } = await supabase
        .from('service_providers')
        .select('provider_payment_status, paypal_provider_subscription_id')
        .eq('user_id', userId)
        .single();

      if (error) throw error;

      return {
        hasPaid: data?.provider_payment_status === 'active',
        status: data?.provider_payment_status,
        subscriptionId: data?.paypal_provider_subscription_id
      };
    } catch (err: any) {
      console.error('Error checking payment status:', err);
      return { hasPaid: false, status: null, subscriptionId: null };
    }
  };

  return {
    initiateProviderSubscription,
    checkProviderPaymentStatus,
    isProcessing,
    error
  };
};
